import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
/*i18n*/
import { makeStyles, TextField } from '@material-ui/core'
import React, { Fragment, FunctionComponent } from 'react'

export interface UserDataFormProps {
  userDataState: any
}

const UserDataForm: FunctionComponent<UserDataFormProps> = ({ userDataState }) => {
  const { userData, setUserData } = userDataState
  const classes = useStyles()

  const handleTextFields = (event: React.ChangeEvent<{ value: string }>) => {
    setUserData({ ...userData, [(event.target as any).name]: event.target.value })
  }

  return (
    <Fragment>
      <div className={classes.form}>
        <label>
          <Trans id='' message='Por favor, diligencie el fomulario con sus datos personales.' />
        </label>
        <TextField
          id='name'
          name='name'
          label={i18n._(`Nombre`)}
          value={userData.name}
          className={classes.textControl}
          onChange={handleTextFields}
          variant='outlined'
          autoFocus={true}
        />
        <TextField
          id='docNumber'
          name='docNumber'
          label={i18n._(`No Documento`)}
          value={userData.docNumber}
          placeholder='Ej: CC-123456'
          className={classes.textControl}
          onChange={handleTextFields}
          variant='outlined'
        />
      </div>
    </Fragment>
  )
}

export default UserDataForm

const useStyles = makeStyles(theme => ({
  form: {
    padding: '0 20px 20px 20px'
  },
  textControl: {
    margin: '0.5em 0 0.5em 0',
    width: '100%'
  },
  btn: {
    width: '100%',
    marginTop: '20px',
    marginBottom: '20px'
  }
}))
